import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import {
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../styles/wizard';
import CurrentPetsFormField from '../../../PostingPath/CurrentPetsFormField';
import PageWizard from '../../../Wizard/PageWizard';
import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const RoomCurrentPets = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
    >
      <Box css={wizardFormSectionContainerStyles.raw()}>
        <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
          Are there pets living on the property?
        </Heading>

        <Paragraph css={wizardParagraphStyles}>Let renters know about any pets that are on the property.</Paragraph>

        <CurrentPetsFormField />
      </Box>
    </PageWizard>
  );
};

export default RoomCurrentPets;
